import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { UserService } from './user.service';

@Component({
  standalone: false,  // this is now required when using NgModule
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  title = 'my-app-bar';

  constructor(public userService: UserService) {}

  ngOnInit() {
  }

}
